import moment from 'moment-timezone';
import React, { useEffect, useRef, useState } from 'react';

import { formatTime, isToday } from 'utils/datetime';

import styles from './styles.module.css';

const CurrentTimeIndicator = ({ dateRange, timezone }) => {
	const [contentHeight, setContentHeight] = useState(0);
	const indicatorRef = useRef(null);

	const todayIndex = dateRange.findIndex((date) => isToday(date.moment, timezone));

	// Control scroll
	useEffect(() => {
		const updateHeight = () => {
			const contentWrapper = document.querySelector('[class*="contentWrapper"]');
			if (contentWrapper) {
				setContentHeight(contentWrapper.scrollHeight);
			}
		};

		updateHeight();

		window.addEventListener('resize', updateHeight);

		// Detect content changes
		const contentWrapper = document.querySelector('[class*="contentWrapper"]');
		let resizeObserver;

		if (contentWrapper) {
			resizeObserver = new ResizeObserver(updateHeight);
			resizeObserver.observe(contentWrapper);
		}

		return () => {
			window.removeEventListener('resize', updateHeight);
			if (resizeObserver) {
				resizeObserver.disconnect();
			}
		};
	}, []);

	if (todayIndex === -1) return null;

	// TODO: MOVE TO UTILS, CLEAN UP UNUSED CONST AND UTILS
	const currentTime = moment().tz(timezone);
	const timelineStart = moment(dateRange[0].moment).startOf('day');
	const timelineEnd = moment(dateRange[dateRange.length - 1].moment).endOf('day');

	// Set offset from the start
	const offsetMinutes = currentTime.diff(timelineStart, 'minutes');
	const totalMinutes = timelineEnd.diff(timelineStart, 'minutes');
	const leftPosition = (offsetMinutes / totalMinutes) * 100;

	return (
		<div
			ref={indicatorRef}
			className={styles.currentTimeIndicator}
			style={{
				left: `${leftPosition}%`,
				height: `${contentHeight}px`,
			}}
		>
			<div className={styles.stickyWrapper}>
				<div className={styles.timeLabel}>{formatTime(new Date(), { timezone })}</div>
				<div className={styles.timeDot} />
				<div className={styles.timeLine} style={{ height: `${contentHeight}px` }} />
			</div>
		</div>
	);
};

export default CurrentTimeIndicator;
